import gql from 'graphql-tag';

export const ProfileDataFragment = gql`
  fragment ProfileDataFragment on Profile {
    name
    photoURL
    coverPhoto

    website

    bio
    dob
    address

    countryCode

    phone
    gender
  }
`;
